export { default as AnalyticsManager } from './analytics-manager'
